import { PostalCodeCreate } from './PostalCodeCreate';
import { PostalCodeEdit } from './PostalCodeEdit';
import { PostalCodeList } from './PostalCodeList';
import { PostalCodeShow } from './PostalCodeShow';

export const create = PostalCodeCreate;
export const edit = PostalCodeEdit;
export const list = PostalCodeList;
export const show = PostalCodeShow;
